// extracted by mini-css-extract-plugin
export default {"invisible":"admin-temporary-access-management-table_invisible__iqnHa"};